import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormRow from '../../../../components/common/form-elements/form-row/form-row'

const TITLE_MAX_LENGTH = 50

const TitleSlideEditDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  title,
  updating
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Edit title</ModalHeader>
    <Formik onSubmit={onSubmit} initialValues={{ title: title || '' }}>
      {({ handleSubmit, handleBlur, handleChange, values }) => {
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="editLessonTitle">
                  <span>Lesson title</span>
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  autoFocus
                  id="editLessonTitle"
                  value={values.title}
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={TITLE_MAX_LENGTH}
                />
              </FormRow>
            </ModalContent>
            <ModalFooter alignRight childrenGap>
              <Button action={onClose} tall simple>
                Cancel
              </Button>
              <Button tall type="submit" disabled={updating}>
                {!updating && 'Save'}
                {updating && 'Saving'}
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(TitleSlideEditDialog)
